// Vue-direktivet v-eui-maintain-disabled kan användas för att styra om fokuserbara element under det element direktivet appliceras på ska vara fokuserbara eller inte.
// Det kan också användas för att styra om allt på sidan *utom* det element direktivet appliceras på ska vara fokuserbara eller inte.
//
// Bygger på ally.js: https://allyjs.io/api/maintain/disabled.html
//
// binding.value (attributets satta värde) ska vara ett objekt enligt följande definition (här med exempelvärden):
//		{
//			disabled: true,							// Om något ska disableas eller inte.
//			wholeDocumentExceptThisElement: false,	// true = det är allt *annat* än själva elementet som ska disableas, false = det är själva elementet med direktivet som ska disableas.
//		}


import Vue from 'vue';
import allyMaintainDisabled from 'ally.js/src/maintain/disabled';


const directive = {

	name: 'eui-maintain-disabled',

	// called only once, when the directive is first bound to the element. This is where you can do one-time setup work.
	bind(el, binding, vnode) {
		//console.log('id=' + vnode.context._self._uid + ' : BIND, value = ' + binding.value);

		// Initial status för Ally Maintain Disabled:
		vnode.$_allyMaintainDisabled = null;
	},

	// called when the bound element has been inserted into its parent node (this only guarantees parent node presence, not necessarily in-document).
	inserted(el, binding, vnode) {
		//console.log('id=' + vnode.context._self._uid + ' : INSERTED, value = ' + binding.value);

		binding.def.aktiveraEllerInaktiveraMaintainDisabled(el, binding, vnode, null);
	},

	// called after the containing component’s VNode has updated, but possibly before its children have updated. The directive’s value may or may not have changed, but you can skip unnecessary updates by comparing the binding’s current and old values (see below on hook arguments).
	update(el, binding, vnode, oldVnode) {
		// Flytta över detta instansvärde:
		vnode.$_allyMaintainDisabled = oldVnode.$_allyMaintainDisabled;

		//console.log('id=' + vnode.context._self._uid + ' : UPDATE, value = ' + binding.oldValue + '–>' + binding.value);

		if (binding.value.disabled !== binding.oldValue.disabled
			|| binding.value.wholeDocumentExceptThisElement !== binding.oldValue.wholeDocumentExceptThisElement)
		{
			binding.def.aktiveraEllerInaktiveraMaintainDisabled(el, binding, vnode, oldVnode);
		}
	},

	//// called after the containing component’s VNode and the VNodes of its children have updated.
	//componentUpdated(el, binding, vnode, oldVnode) {
	//},

	// called only once, when the directive is unbound from the element.
	unbind(el, binding, vnode)
	{
		// Avbryt, om disable pågår:
		binding.def.inaktiveraMaintainDisabledOmDenÄrAktiverad(el, vnode);
	},


	// Helper methods:   ==========================================================================================

	aktiveraEllerInaktiveraMaintainDisabled(el, binding, vnode, oldVnode)
	{
		//console.log('–> id=' + vnode.context._self._uid + ' : maintainDisabled ' + binding.oldValue + '–>' + binding.value + ', $_allyMaintainDisabled = ' + vnode.$_allyMaintainDisabled);

		if (binding.value.disabled)
		{
			// Avbryt först, om disable pågår (vet inte om detta behövs egentligen, men kanske ökat behov i och med Vue:s trix med DOM och att vi nu har två settings under value?):
			binding.def.inaktiveraMaintainDisabledOmDenÄrAktiverad(el, vnode);

			// Arguments:
			//Name		Type			Default				Description
			//context	<selector>	documentElement	The scope of the DOM in which to search. The first element of a collection is used.
			//filter		<selector>	null					The significant elements to exclude from being disabled.

			if (binding.value.wholeDocumentExceptThisElement)
			{
				// Gör allt *utom* elementets innehåll helt otillgängligt (musklick, snabbvalsbokstav, tab/bakåttab...):
				vnode.$_allyMaintainDisabled = allyMaintainDisabled({
					filter: el,
				});
			}
			else
			{
				// Gör *elementets* innehåll helt otillgängligt (musklick, snabbvalsbokstav, tab/bakåttab...):
				vnode.$_allyMaintainDisabled = allyMaintainDisabled({
					context: el,
				});
			}

			vnode.context.$emit('eui-maintain-disabled-aktiverad', { element: el, value: binding.value });
		}
		else {
			// Annars: Avbryt, om disable pågår:
			binding.def.inaktiveraMaintainDisabledOmDenÄrAktiverad(el, vnode);
		}

		//console.log('<– id=' + vnode.context._self._uid + ' : maintainDisabled ' + binding.oldValue + '–>' + binding.value + ', $_allyMaintainDisabled = ' + vnode.$_allyMaintainDisabled);
	},




	inaktiveraMaintainDisabledOmDenÄrAktiverad(el, vnode) {
		// Avbryt, om disable pågår:

		//vnode.$_allyMaintainDisabled && vnode.$_allyMaintainDisabled.disengage();

		if (vnode.$_allyMaintainDisabled)
		{
			vnode.$_allyMaintainDisabled.disengage();
			vnode.context.$emit('eui-maintain-disabled-inaktiverad', { element: el });
			vnode.$_allyMaintainDisabled = null;	// För tydlighet!

			//// Dessutom, sätt autofocus om sådan finns inom det disengageade elementet:
			//// Funkar bara delvis, i fallet med menyn i SSO så funkar det när man med klick öppnar menyn, men *inte* när man skalar om fönstret så att menyn dyker upp (omskalning/mus-drag blurar nog):
			//let afEl = el.querySelector("[autofocus]");
			//afEl && afEl.focus();
		}
	}
};


//const registerDirectiveGlobally = function () {
//	Vue.directive(directive.name, directive);
//};


//const euiMaintainTabDisabled = {
//	// Properties:
//	directive,

//	// Methods:
//	registerDirectiveGlobally
//};

export default directive;
